import { useEffect, useState } from "react";
import Web3 from "web3";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { networkParams } from "./networks";
import { Rings } from "react-loader-spinner";

import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected,
} from "@web3-react/injected-connector";
import { UserRejectedRequestError as UserRejectedRequestErrorWalletConnect } from "@web3-react/walletconnect-connector";
// import { SwitchNetwork } from "./helpers";
import connectors from "./connectors";
import { Modal, ErrorModal } from "../components/Modal";

import mm from "./img/mm.png";
import wc from "./img/wc.png";
import cbw from "./img/cb.png";
import lew from "./img/lw.png";
import tzw from "./img/tw.png";
// import trw from "./img/tr.png";
import "./wallet.css";

// info for wallet list of modal, 1.Name, 2.icon, 3.provoider
const walletInfo = [
  ["Metamask", mm, "Injected"],
  ["Wallet Connect", wc, "WalletConnect"],
  ["Coinbase", cbw, "CoinbaseWallet"],
  ["Trezor", tzw, "Trezor"],
  ["Ledger", lew, "Ledger"],
];

// wallet connect button of nav with modal
export const WalletButton = () => {
  let { library, chainId, account, activate, deactivate, active, error } =
    useWeb3React();

  const [showModal, setShowModal] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const [errorContent, setErrorContent] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);

  const disconnect = () => {
    setProvider(null);
    deactivate();
  };

  const setProvider = (str) => {
    window.localStorage.setItem("provider", str);
  };

  // content of modal when is connecting status
  const loading = (
    <div>
      <div className="d-flex justify-content-center text-center">
        <Rings color="#555" height={50} width={50} />
      </div>
      <p>Login or Authentication to Wallet.</p>
      <p>Would you switch wallet? </p>
    </div>
  );

  // footer of modal when is connecting status
  const switchWalletButton = (
    <button
      className="btn switch-wallet-button"
      onClick={() => {
        setConnecting(false);
        disconnect();
      }}
    >
      Switch Wallet
    </button>
  );

  // wallet list of modal when is not connecting status
  const walletList = walletInfo.map((wallet, index) => {
    return (
      <div
        className="row wallet-item"
        key={index}
        onClick={async () => {
          setConnecting(true);
          try {
            await activate(connectors[wallet[2]]);
            setConnecting(false);
            setProvider([wallet[2]]);
            setShowModal(false);
          } catch (err) {
            setErrorContent(err);
            setShowErrorModal(true);
          }
        }}
      >
        <div className="d-flex wallet-item-content">
          <div className="wallet-img-parent">
            <img className="wallet-img" src={wallet[1]} alt="Metamask" />
          </div>
          <div className="wallet-name">{wallet[0]}</div>
        </div>
      </div>
    );
  });

  useEffect(() => {
    const provider = window.localStorage.getItem("provider");
    if (provider) {
      activate(connectors[provider]);
    }
  }, [activate]);

  useEffect(() => {
    if (!error) {
      setErrorContent("");
      return;
    }
    if (error instanceof NoEthereumProviderError) {
      return "No Ethereum browser extension detected, install MetaMask on desktop or visit from a dApp browser on mobile.";
    } else if (error instanceof UnsupportedChainIdError) {
      return "You're connected to an unsupported network.";
    } else if (
      error instanceof UserRejectedRequestErrorInjected ||
      error instanceof UserRejectedRequestErrorWalletConnect
    ) {
      return "Please authorize this website to access your Ethereum account.";
    } else if (error.code === -32002) {
      setErrorContent(
        "Already exist request. You have to process request. Please check your wallet."
      );
    } else {
      return;
    }
    setShowErrorModal(true);
  }, [error]);

  useEffect(() => {
    if (!active) return;
    const switchNetwork = async (id) => {
      if (!library) return;
      try {
        await library.currentProvider.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: Web3.utils.toHex(id) }],
        });
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          await library.currentProvider.request({
            method: "wallet_switchEthereumChain",
            params: [networkParams[Web3.utils.toHex(id)]],
          });
          setErrorContent("add this chain id:" + id);
          setShowErrorModal(true);
        }
      }
    };
    if (chainId && chainId !== Number.parseInt(process.env.REACT_APP_CHAINID)) {
      setErrorContent("Network is not for our site. Please switch network.");
      setShowErrorModal(true);
      switchNetwork(process.env.REACT_APP_CHAINID);
    } else {
      setShowErrorModal(false);
    }
  }, [library, chainId, active]);

  return (
    <>
      <button
        className="btn d-flex align-items-center my-2 primary-button-reverse nav-link"
        type="button"
        onClick={() => (active ? disconnect() : setShowModal(true))}
        style={{ maxWidth: "190px", overflow: "hidden" }}
      >
        <i className="icon-wallet ms-2"></i>
        <span className="me-2">
          {active ? account.substring(0, 4) + "...." + account.substring(account.length - 4) : connecting ? "Loading..." : "Connect"}
        </span>
      </button>
      <ErrorModal
        title={"Error"}
        content={errorContent}
        onClose={() => setShowErrorModal(false)}
        show={showErrorModal}
      />
      <Modal
        title={connecting ? "Connecting" : "Wallet Connect"}
        content={connecting ? loading : walletList}
        footer={connecting ? switchWalletButton : "Please Select"}
        onClose={() => setShowModal(false)}
        show={showModal}
      />
    </>
  );
};
